import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TerminalsService } from '../../../services/terminals.service';

@Component({
    selector: 'terminals-default',
    templateUrl: './terminals-default.component.html',
    styleUrls: ['./terminals-default.component.css'],
    standalone: false
})
export class TerminalsDefaultComponent {

  constructor(private terminalsService: TerminalsService, private router: Router) {
    if (this.terminalsService.isEditMode) {
      this.terminalsService.stopEditMode();
    }

    if (!this.router.url.includes('/terminals')) {
      this.router.navigate(['/terminals/']);
    }
  }

}
